// test1087
(1087 && 0);
